module.exports = __webpack_public_path__ + "static/img/LOGO.a025918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/KOF14/LOGO.png
// module id = NiAk
// module chunks = 0